import { render } from "./NotificationsHeader.vue?vue&type=template&id=15d040aa&scoped=true"
import script from "./NotificationsHeader.vue?vue&type=script&lang=js"
export * from "./NotificationsHeader.vue?vue&type=script&lang=js"

import "./NotificationsHeader.vue?vue&type=style&index=0&id=15d040aa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d040aa"]])

export default __exports__